module.exports = __webpack_public_path__ + "img/ipad-gestures-1.991d7d3.jpg";